"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RouteGenerator_1 = __importDefault(require("../../Core/RouteGenerator"));
var SessionBasedService_1 = require("../../Services/SessionBasedService");
var SERVICE_PREFIX = '/chat-service/v2';
var Routes = {
    CHAT_MERCHANT_APP: "".concat(SERVICE_PREFIX, "/merchant-apps"),
    CHAT_MERCHANT_APP_EXISTS: "".concat(SERVICE_PREFIX, "/merchant-apps/exists"),
    GET_OR_CREATE_CHAT_MERCHANT_APP: "".concat(SERVICE_PREFIX, "/merchant-apps/get-or-create"),
    GET_OR_CREATE_CHAT_USER: "".concat(SERVICE_PREFIX, "/chat-users/get-or-create"),
    GET_UNREAD_MESSAGE_COUNT: "".concat(SERVICE_PREFIX, "/chat-users/unread-message-count"),
    GET_OR_CREATE_CHAT_MEMBERS: "".concat(SERVICE_PREFIX, "/chat-members/get-or-bulk-create"),
    GET_USERS_AVAILABLE_TO_CHAT: "".concat(SERVICE_PREFIX, "/bringg-users/available-to-chat"),
    CHAT_AUTO_EVENT_MESSAGE: "".concat(SERVICE_PREFIX, "/merchant-apps/auto-event-message")
};
var ChatService = /** @class */ (function (_super) {
    __extends(ChatService, _super);
    function ChatService(session) {
        var _this = _super.call(this, session.config.getApiEndpoint(), session) || this;
        _this.entityName = 'chat';
        _this.routeGenerator = new RouteGenerator_1.default(_this);
        return _this;
    }
    ChatService.prototype.getChatMerchantApp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator.get(Routes.CHAT_MERCHANT_APP).invoke()];
            });
        });
    };
    ChatService.prototype.getOrCreateChatMerchantApp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator.post(Routes.GET_OR_CREATE_CHAT_MERCHANT_APP).invoke()];
            });
        });
    };
    ChatService.prototype.getChatMerchantAppExists = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator.get(Routes.CHAT_MERCHANT_APP_EXISTS).invoke()];
            });
        });
    };
    ChatService.prototype.getOrCreateChatUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator.post(Routes.GET_OR_CREATE_CHAT_USER).invoke()];
            });
        });
    };
    ChatService.prototype.getUnreadMessageCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator.get(Routes.GET_UNREAD_MESSAGE_COUNT).invoke()];
            });
        });
    };
    ChatService.prototype.getOrCreateChatMembers = function (bringgUsersIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator.post(Routes.GET_OR_CREATE_CHAT_MEMBERS).withPayload({ bringgUsersIds: bringgUsersIds }).invoke()];
            });
        });
    };
    ChatService.prototype.getUsersAvailableToChat = function (_a) {
        var _b = _a === void 0 ? {} : _a, bringUserIds = _b.bringUserIds;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, this.routeGenerator
                        .post(Routes.GET_USERS_AVAILABLE_TO_CHAT)
                        .withPayload(__assign({}, (bringUserIds ? { bringUserIds: bringUserIds } : null)))
                        .invoke()];
            });
        });
    };
    ChatService.prototype.configureAutoEventMessage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.routeGenerator.put(Routes.CHAT_AUTO_EVENT_MESSAGE).invoke()];
            });
        });
    };
    return ChatService;
}(SessionBasedService_1.SessionBasedService));
exports.default = ChatService;
//# sourceMappingURL=Chat.service.js.map